import { useMutation, useQueryClient } from '@tanstack/react-query';

import { googleConnectionsQueryKey } from '@/hooks/queries/google-connections/use-google-connections';
import {
  disconnectGoogleConnection,
  initiateGoogleConnection,
} from '@/services/google-connections/google-connections';
import { GoogleService } from '@/services/google-connections/types';

const useInvalidateGoogleConnections = (orgId?: string) => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.invalidateQueries({
      queryKey: googleConnectionsQueryKey(orgId),
    });
};

export const useInitiateGoogleConnection = (orgId?: string) => {
  const invalidate = useInvalidateGoogleConnections(orgId);
  return useMutation({
    mutationFn: (service: GoogleService) =>
      initiateGoogleConnection(orgId!, service),
    onSuccess: invalidate,
  });
};

export const useDisconnectGoogleConnection = (orgId?: string) => {
  const invalidate = useInvalidateGoogleConnections(orgId);
  return useMutation({
    mutationFn: ({
      service,
      pendingOnly = false,
    }: {
      service: GoogleService;
      pendingOnly?: boolean;
    }) => disconnectGoogleConnection(orgId!, service, pendingOnly),
    onSettled: invalidate,
  });
};
